<template>
    <div class="flex items-center">
        <h6 class="mr1">{{title}}:</h6>
        <slot></slot>
        <img @click="showInfo = true" class="pointer w1 ml2 grow" v-if="description !== ''" src="@/assets/img/icon_info.svg"/> 

        <OverlayWarning :showWarning="showInfo">
            <InfoOverlay
                :title="title"
                :description="description"
                @cancel="showInfo = false"
            />
        </OverlayWarning>
    </div>



</template>

<script>
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import InfoOverlay from '@/components/global/InfoOverlay.vue';

export default {
    data() {
        return {
            showInfo: false
        };
    },
    components: {
        OverlayWarning,
        InfoOverlay
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        }
    }
};
</script>
